import React, {useEffect} from 'react';

import {useDispatch} from 'react-redux';

import {updateActiveMenu} from '@/actions/setupActions';
import {WIFI_SETTING, WIFI_STATUS} from '@/constants/pcConstAppData';
import {useWifiStatusContext} from '@/contexts/WifiStatusContext';

import BottomMenu from '../../menu/bottommenu/BottomMenu';

import AvailableWifiListContainer from './AvailableWifiListContainer';
import WifiSettingTopMenu from './WifiSettingTopMenu';
import WifiUnavailable from './WifiUnavailable';

import './WifiSetting.less';

function WifiSetting() {
  const dispatch = useDispatch();
  const {wifiStatus} = useWifiStatusContext();

  useEffect(() => {
    dispatch(updateActiveMenu(WIFI_SETTING));
  }, []);

  return (
    <>
      <WifiSettingTopMenu />
      {wifiStatus === WIFI_STATUS.OFF ? <WifiUnavailable /> : <AvailableWifiListContainer />}
      <BottomMenu />
    </>
  );
}
export default WifiSetting;
